import { render, staticRenderFns } from "./UpdateCustomerGroup.vue?vue&type=template&id=58372359"
import script from "./UpdateCustomerGroup.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports